<div
  class="flex flex-col gap-5 divide-y divide-gray-200"
  [formGroup]="formGroup"
>
  <div class="grid gap-7 pt-7.5">
    <div class="placeholder flex flex-col items-start text-start">
      <span class="text-md text-gray-900 font-semibold">{{
        resolvePlaceholders(fields.displayName)
      }}</span>
      <span class="text-2sm text-gray-500 font-medium w-500px">{{
        resolvePlaceholders(fields.helpText)
      }}</span>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-7.5">
      <!-- sso-active singl-sign-on-bg -->

      <label
        class="flex flex-col justify-between items-center bg-center min-h-[220px] bg-no-repeat border rounded-xl border-dashed bg-[length:500px] px-4 py-4 relative overflow-hidden transition-colors duration-200"
        *ngFor="let option of fieldsData"
        [ngClass]="{
          'border-primary border-1 bg-light-primary': isSelected(option),
          'border-gray-300 opacity-50': isDisabled(option),
          'border-gray-300': !isSelected(option) && !isDisabled(option),
          'disabled-card': isDisabled(option),
        }"
        [class.pointer-events-none]="isDisabled(option)"
      >
        <div class="flex flex-col items-center text-center gap-2 w-full">
          <div class="flex items-center justify-center h-12">
            <img
              alt=""
              class="w-10 h-10 object-contain"
              [src]="
                option.name === 'Default eCISO SMTP'
                  ? 'assets/media/icons/mini-logo.png'
                  : option.iconUrl
              "
            />
          </div>

          <span class="text-md font-semibold text-gray-800 leading-5">
            {{ option.name }}
          </span>

          <span
            class="text-2sm text-gray-600 text-center leading-5 px-2 break-words"
          >
            {{ option.subText }}
          </span>

          <input
            class="appearance-none"
            name="sso_option"
            type="radio"
            [value]="option?._id"
            [checked]="isSelected(option)"
            (change)="toggleSelection(option)"
          />
        </div>

        <div class="flex justify-center w-full">
          <input
            class="appearance-none"
            name="sso_option"
            type="radio"
            [value]="option?._id"
            [checked]="isSelected(option)"
            [disabled]="!isSelected(option)"
            (change)="toggleSelection(option)"
          />

          <!-- Disconnect Button -->
          <button
            *ngIf="isSelected(option)"
            type="button"
            class="btn btn-sm btn-secondary border border-gray-300 hover:border-gray-500 transition-all duration-200"
            (click)="
              resetSelection(
                option._id,
                formGroup.get(fields.fieldName + 'Tags')
              )
            "
          >
            Disconnect
          </button>

          <!-- Activate / Configure Button -->
          <button
            *ngIf="!isSelected(option)"
            type="button"
            class="btn btn-sm"
            [disabled]="isDisabled(option)"
            [ngClass]="{
              'btn-primary': option.fieldDependencies != null,
              'btn-secondary': option.fieldDependencies == null,
              'opacity-50 cursor-not-allowed': isDisabled(option),
            }"
            (click)="toggleSelection(option)"
          >
            {{ !option.fieldDependencies ? "Activate" : "Configure" }}
          </button>
        </div>
      </label>
    </div>
  </div>
</div>
<div class="separator mt-5 mb-2"></div>
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'connection_modal_' + fields.fieldName"
>
  <div
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg bg-white shadow-lg dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="card-title font-semibold text-base ms-2">{{
        modalTitle
      }}</span>
      
    </div>
    <div class="modal-body gap-5 p-4">
      <app-modal-renderer
        #modalRendererRef
        *ngIf="activeModalContext"
        [nodeId]="currentNodeId"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal('connection_modal_' + fields.fieldName)"
        [workflowData]="workflowData"
        [workflowId]="workflowId"
        (clickedOnPrevious)="clickedOnPrevious()"
        (header)="setModalTitle($event)"
        (checkPollingServiceForError)="checkPollingServiceForError($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>
